var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tree',{ref:"menuTree",staticClass:"filter-tree",attrs:{"data":_vm.leftdata,"props":_vm.defaultProps,"node-key":"name"},on:{"node-click":_vm.handleNodeClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }